import ContextToggler from './context-toggler';

const withTitleClass = 'withTitle';

class ModalToggler extends ContextToggler {
	toggle(value = null) {
		value = value === null ? !this.toggled : !!value;
		if (value) {
			const contextElement = this.contexts.getContext(this.dataAttr().get('forContext')).getElement();
			console.log('contextElement', contextElement);
			const title = this.dataAttr().get('title', '');
			const content = this.dataAttr().get('content', '');
			const titleElement = contextElement.querySelector(this.dataSelector('title'));
			if (titleElement) {
				titleElement.innerHTML = title;
			}
			const contentElement = contextElement.querySelector(this.dataSelector('content'));
			if (contentElement) {
				contentElement.innerHTML = content;
			}
			this.classList(contextElement).toggle(withTitleClass, title.length > 0);
		}
		return super.toggle(value);
	}
}

export default ModalToggler;
